export const getCurrencySymbol = (currency) => {
  switch (currency) {
  case 'USD':
    return '$';
  case 'EUR':
    return '€';
  case 'GBP':
    return '£';
  case 'INR':
    return '₹';
  case 'AUD':
    return 'A$';
  default:
    return '';
  }
};

export const formatCurrency = (amount, currency) => {
  if (amount == null) return '';

  let locale = 'en-US';
  let useGrouping = false;

  if (currency === 'INR') {
    locale = 'en-IN';
    useGrouping = true;
  }

  const options = {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: useGrouping,
  };

  return new Intl.NumberFormat(locale, options).format(amount);
};

